import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'

import buildUrl from 'modules/core/lib/buildUrl'

import type { ExpensableGroup } from './types'

export const Owner = ({ owner }: { owner: ExpensableGroup['owner'] }) => (
  <Box flexDirection="row" alignItems="center" gap="s16">
    <Box width="s40">
      <Avatar
        size="s40"
        url={buildUrl(owner?.access?.avatar)}
        label={owner?.access?.fullName ?? ''}
      />
    </Box>
    <Text.Normal weight="medium">{owner?.access?.fullName}</Text.Normal>
  </Box>
)
